var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7844_5112)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.625 6.5C1.625 3.80761 3.80761 1.625 6.5 1.625C9.19239 1.625 11.375 3.80761 11.375 6.5C11.375 9.19239 9.19239 11.375 6.5 11.375C3.80761 11.375 1.625 9.19239 1.625 6.5ZM-4.76837e-07 6.5C-4.76837e-07 2.91015 2.91015 -4.76837e-07 6.5 -4.76837e-07C10.0899 -4.76837e-07 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 -4.76837e-07 10.0899 -4.76837e-07 6.5ZM5.6875 5.72283C5.6875 5.25458 6.05127 4.875 6.5 4.875C6.94873 4.875 7.3125 5.25458 7.3125 5.72283L7.3125 9.44384C7.3125 9.91208 6.94873 10.2917 6.5 10.2917C6.05127 10.2917 5.6875 9.91208 5.6875 9.44384L5.6875 5.72283ZM5.6875 3.52083C5.6875 3.51494 5.68756 3.50905 5.68767 3.50318C5.69669 3.96327 6.05693 4.33334 6.5 4.33334C6.94308 4.33334 7.30332 3.96325 7.31233 3.50316C7.31244 3.50902 7.3125 3.51489 7.3125 3.52078L7.3125 3.48551C7.3125 3.49141 7.31244 3.49729 7.31233 3.50316C7.30331 3.04308 6.94307 2.67301 6.5 2.67301C6.05692 2.67301 5.69668 3.04309 5.68767 3.50318C5.68756 3.49732 5.6875 3.49145 5.6875 3.48556L5.6875 3.52083Z",
    fill: "#55489E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7844_5112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "matrix(-1 0 0 -1 13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info-outline.f6a6e882.svg";
export { ForwardRef as ReactComponent };